import { render, staticRenderFns } from "./uploadPicss.vue?vue&type=template&id=1dc7184a&scoped=true&"
import script from "./uploadPicss.vue?vue&type=script&lang=js&"
export * from "./uploadPicss.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicss.vue?vue&type=style&index=0&id=1dc7184a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7184a",
  null
  
)

export default component.exports